import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Dumbbell, TrendingUp, LayoutGrid, ShoppingBag, Calendar, Receipt, LogOut } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_261f6229-25c6-462a-bf7c-d1c15ef074eb/artifacts/rv1gzzra_logo%20v2%20xpro.png";

export default function UserNav({ user, onLogout }) {
  const { pathname } = useLocation();
  const tabs = [
    { to: "/inicio",       label: "Inicio",    icon: Home },
    { to: "/mi-rutina",    label: "Rutina",    icon: Dumbbell },
    { to: "/mi-evolucion", label: "Evolución", icon: TrendingUp },
    { to: "/catalogo",     label: "Máquinas",  icon: LayoutGrid },
    { to: "/tienda",       label: "Tienda",    icon: ShoppingBag },
    { to: "/reservas",     label: "Reservas",  icon: Calendar },
    { to: "/mis-compras",  label: "Compras",   icon: Receipt },
  ];

  return (
    <header className="sticky top-0 z-10 bg-black border-b border-white/10" data-testid="user-nav">
      {/* Row 1 — Logo centrado */}
      <div className="flex items-center justify-center px-4 h-12 border-b border-white/8 relative">
        <img src={LOGO} alt="XPRO FITNESS" className="h-7 w-auto" />
        <button
          onClick={onLogout}
          data-testid="logout-btn"
          className="absolute right-4 text-white/35 hover:text-white/70 transition-colors"
          title="Cerrar sesión"
        >
          <LogOut size={17} />
        </button>
      </div>

      {/* Row 2 — Nav tabs */}
      <nav className="flex items-stretch overflow-x-auto no-scrollbar">
        {tabs.map(({ to, label, icon: Icon }) => {
          const active = pathname === to || pathname.startsWith(to + "/");
          return (
            <Link
              key={to}
              to={to}
              data-testid={`nav-${to.slice(1)}`}
              className={`flex-1 min-w-[52px] flex flex-col items-center justify-center gap-1 py-2.5 px-1 transition-colors border-b-2 ${
                active
                  ? "border-[#F2C230] text-[#F2C230]"
                  : "border-transparent text-white/45 hover:text-white/80"
              }`}
            >
              <Icon size={19} strokeWidth={active ? 2.5 : 1.8} />
              <span className="text-[9px] font-bold tracking-wide uppercase whitespace-nowrap">{label}</span>
            </Link>
          );
        })}
      </nav>
    </header>
  );
}
